// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__XR05r","body":"style__body__z4Xka","header":"style__header__vyDVI","footer":"style__footer__lX24f","buttonIcon":"style__buttonIcon__aHc3l"};